<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div>
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="financingExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->
        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Financing Tabs -->
    <financing-tabs v-if="!loading" class="mb-4" />
    <!-- /Financing Tabs -->

    <!-- Financing List -->
    <financing-list class="mb-4" />
    <!-- /Financing List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'setUp'"
      :step="'financing'"
      :concept-name="'financingMoreDetails'"
      :completed-step-name="'financingCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="financingExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="financing"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import FinancingList from '@/views/Home/StoryMode/FinancialPlan/Components/Financing/FinancingList.vue'
import FinancingTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Financing/FinancingTabs.vue'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'Financing',

  components: {
    FinancingList,
    AddMoreDetails,
    FinancingTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [
    MixinGuide,
    MixinIdeaRoles,
    MixinAiBuddyDrawer
  ],

  data () {
    return {
      loading: false
    }
  },

  mounted () {
    this.openGuide('financingFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
